// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App';
import axios from "axios";
import VueRouter from "vue-router";
import Config from './config';
import {
  /* eslint-disable no-unused-vars */
  Style,
  Input,
  Button,
  Toast,
  Dialog,
} from "cube-ui";

Vue.use(Style);
Vue.use(Input);
Vue.use(Button);
Vue.use(Toast);
Vue.use(Dialog);
Vue.config.productionTip = false;
Vue.use(VueRouter);

Vue.prototype.$http = axios;
axios.defaults.headers.common["s"] = "h5";
axios.defaults.headers.common["Content-Type"] = "application/json";
axios.defaults.baseURL = Config.url;

const routes = [
  { path: "*", component: App },
];

const router = new VueRouter({
  mode: 'history',
  routes // (缩写) 相当于 routes: routes
});

/* eslint-disable no-new */
new Vue({
  el: '#app',
  components: { App },
  template: '<App/>',
  router,
})



// WEBPACK FOOTER //
// ./src/pages/message-verification/index.js